import React from 'react';

import 'react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css';




/*   const headCells = [
    { id: 'codigo_loja', numeric: true, disablePadding: true, label: 'Loja' },
    { id: 'des_nome', numeric: true, disablePadding: false, label: 'Danfe' },
    { id: 'numero_danfe', numeric: false, disablePadding: false, label: 'Cliente' },
    { id: 'pedido', numeric: false, disablePadding: false, label: 'Pedido' },
    { id: 'data_emissao', numeric: true, disablePadding: false, label: 'Data de Emissão' },
    { id: 'status', numeric: true, disablePadding: false, label: 'Status' },
  ]; */

export default class DanfeList extends React.Component{
    
  
    
    state = {
        rows: []
    };

    componentDidMount() {
        fetch('http://localhost:8080/api/consultadanfe')
            .then(res => res.json())
            .then(res => {
                this.setState({
                    rows: res
                });
            });
    }


    render() {
        return (
            <div className="card">
                <div className="card-header">
                    Consulta de Danfes
                </div>
                <div className="card-body">
            </div>
            <table className="table table-hover" > 
                <thead>
                    <tr> 
                        <th>Loja</th>
                        <th>Cliente</th>
                        <th>Danfe</th>
                        <th>Pedido</th>
                        <th>Data de Emissão</th>
                        <th>Status</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                {this.state.rows.map(item => {
                    return (
                        <tr>
                            <th>{item.codigo_loja}</th>
                            <th>{item.des_nome}</th>
                            <th>{item.numero_danfe}</th>
                            <th>{item.pedido}</th>
                            <th>{item.data_emissao}</th>
                            <th>{item.status}</th>
                            <th></th>
                        </tr>
                    )                            
                    })}
                </tbody>
            </table>
            </div>
        )
    }
}